import {createSvgIcon} from '@yandex-delivery/blocks/icons/utils'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import React from 'react'

const className = css`
  inline-size: ${spacing(18.75)};
  block-size: ${spacing(10.625)};
`
export default createSvgIcon(
  <svg
    className="footer__icon"
    fill="none"
    height="84"
    viewBox="0 0 150 84"
    width="150"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      height="82"
      rx="11"
      stroke="white"
      strokeWidth="2"
      width="148"
      x="1"
      y="1"
    />
    <path
      d="M95.1944 57.7944L21.9336 57.7944V26.8175L95.1944 26.8175V15.2812L135.289 42.9468L95.1944 70.6124V57.7944Z"
      fill="white"
    />
  </svg>,
  'ArrowSquareShort',
  {viewBox: '0 0 150 84', className},
)
